/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query PhoneNumberoRouteReadQuery($type: CUSTOMER_TYPE!, $take: PositiveInt, $skip: Int, $search: String,) {
    PhoneNumberoRouteRead(type: $type, take: $take, skip: $skip, search: $search) {
      id,
      createdAt,
      updatedAt,
      displayName,
      type,
      message,
      status,
      _totalCount,
      Account {
        email
        displayName
      }
      PhoneNumberoRoutePlan {
        id,
        Mcc {
          mcc
        },
        Mnc {
          mnc,
          network
        }
      }
    }
  }
`
